import { Observable } from 'rxjs';
import { ContentType, NotebookType } from '../notebook.types';
import { DataViewTypes } from '@mode/shared/contract-common';

export abstract class CellExportFacade {
  abstract isExporting$: Observable<boolean>;
  abstract exportingCellToken$: Observable<string | null>;
  abstract inProgressToastId$: Observable<number | null>;

  // TODO: refactor legacy state selectors to new facade for common use
  abstract notebookToken$: Observable<string>;
  abstract notebookSession$: Observable<any>;
  abstract notebookState$: Observable<any>;
  abstract notebookCellState$: Observable<any>;
  abstract queries$: Observable<any>;
  abstract selectedNotebookType$: Observable<NotebookType>;

  abstract selectedCellToken$: Observable<string>;
  abstract selectedCellContentType$: Observable<ContentType>;
  abstract selectedCellIsExported$: Observable<boolean>;

  abstract isPython$: Observable<boolean>;

  abstract isExportingByCell$(cellToken: string): Observable<boolean>;
  abstract exportCell(cellToken: string, cellContentType: ContentType, datasetName: string): void;
  abstract getDatasetResultByCellToken(cellToken: string): Observable<DataViewTypes.DatasetResult | undefined>;
  abstract getDatasetResults(): Observable<DataViewTypes.DatasetResult[]>;
}
